export const determineColorBasedOnTime = (enteringTime, leavingTime) => {
  const enteringHour = parseInt(enteringTime.split(":")[0], 10);
  const leavingHour = parseInt(leavingTime.split(":")[0], 10);

  if (enteringHour === 12 || leavingHour === 12) {
    return "red";
  } else if (
    (enteringHour >= 9 && enteringHour <= 16) ||
    (leavingHour >= 9 && leavingHour <= 16)
  ) {
    return "blue";
  }
};
